import { SERVICES } from "@/lib/constants";
import { ChapterLabel, MaskReveal, Reveal } from "@/components/Reveal";

export default function Services({ onBook }) {
  return (
    <section
      id="services"
      data-testid="services-section"
      className="relative border-y border-[#B08D2E]/10 bg-[#F4EFE4] py-28 sm:py-36"
    >
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="flex flex-col gap-10 lg:flex-row lg:items-end lg:justify-between">
          <div>
            <ChapterLabel index="02" title="Our Core Services" testId="chapter-services" />
            <h2 className="mt-8 max-w-2xl font-display text-4xl font-light leading-[1.08] tracking-tight text-[#1A1A1A] sm:text-5xl lg:text-6xl">
              <MaskReveal>Care for every</MaskReveal>
              <MaskReveal delay={0.12}>
                <em className="gold-text font-medium italic">thread you own.</em>
              </MaskReveal>
            </h2>
          </div>
          <Reveal delay={0.2}>
            <p className="max-w-sm text-sm font-light leading-relaxed tracking-wide text-[#6E675C]">
              Every garment is inspected, treated and finished by hand. Share your
              items on WhatsApp and we will tailor the care — no price lists, just
              honest, personal service.
            </p>
          </Reveal>
        </div>

        <div className="mt-20 grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-4">
          {SERVICES.map((service, i) => {
            const Icon = service.icon;
            return (
              <Reveal key={service.slug} delay={0.07 * (i % 4)}>
                <article
                  data-testid={`service-card-${service.slug}`}
                  className="group relative flex h-full flex-col border border-[#B08D2E]/20 bg-[#FFFFFF] p-9 shadow-[0_4px_24px_rgba(26,26,26,0.04)] transition-[transform,border-color,box-shadow,background-color] duration-500 hover:-translate-y-1.5 hover:border-[#B08D2E]/55 hover:bg-[#FBF8F0] hover:shadow-[0_20px_50px_rgba(176,141,46,0.12)]"
                >
                  <span className="absolute right-6 top-6 font-display text-lg italic text-[#B08D2E]/25 transition-colors duration-500 group-hover:text-[#B08D2E]/60">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                  <span className="flex h-12 w-12 items-center justify-center border border-[#B08D2E]/25 transition-[border-color,background-color] duration-500 group-hover:border-[#B08D2E]/60 group-hover:bg-[#B08D2E]/5">
                    <Icon className="h-5 w-5 text-[#B08D2E]" strokeWidth={1.25} />
                  </span>
                  <h3 className="mt-8 font-display text-[1.4rem] font-medium leading-snug text-[#1A1A1A]">
                    {service.name}
                  </h3>
                  <p className="mt-3 text-sm font-light leading-relaxed tracking-wide text-[#6E675C]">
                    {service.description}
                  </p>
                  <span className="mt-auto block pt-8">
                    <span className="block h-px w-10 bg-[#B08D2E]/30 transition-[width,background-color] duration-500 group-hover:w-full group-hover:bg-[#B08D2E]/60" />
                  </span>
                </article>
              </Reveal>
            );
          })}
        </div>

        <Reveal delay={0.15} className="mt-16">
          <div className="flex flex-col items-start gap-6 border border-[#B08D2E]/15 bg-[#FFFFFF] p-8 sm:flex-row sm:items-center sm:justify-between sm:p-10">
            <p className="max-w-md font-display text-2xl font-light italic text-[#1A1A1A]">
              Not sure what your garment needs?{" "}
              <span className="gold-text font-medium">Just ask us.</span>
            </p>
            <button
              data-testid="services-book-pickup-btn"
              onClick={onBook}
              className="group relative shrink-0 overflow-hidden bg-[#B08D2E] px-9 py-4 text-[11px] font-semibold uppercase tracking-[0.25em] text-[#F4EFE4] transition-colors duration-300 hover:bg-[#96771F]"
            >
              <span className="pointer-events-none absolute inset-0 -translate-x-full bg-gradient-to-r from-transparent via-white/50 to-transparent transition-transform duration-700 ease-out group-hover:translate-x-full" />
              Book a Pickup
            </button>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
